var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    {
      staticClass: "p-3 mt-2 bg-white shadow-sm bg-white",
      class: { selected: _vm.file.idAprobacion === _vm.selectedFile }
    },
    [
      _c(
        "vs-col",
        { attrs: { "vs-lg": "11" } },
        [
          _c(
            "vs-row",
            [
              _c(
                "vs-col",
                {
                  staticClass: "text-center text-primary",
                  attrs: { "vs-lg": "1" }
                },
                [
                  _vm.showCheck
                    ? _c(
                        "div",
                        { staticClass: "text-center m-auto" },
                        [
                          _vm.process && !_vm.isBlocked
                            ? _c("b-form-checkbox", {
                                on: { change: _vm.selectFileToProcess },
                                model: {
                                  value: _vm.file.selected,
                                  callback: function($$v) {
                                    _vm.$set(_vm.file, "selected", $$v)
                                  },
                                  expression: "file.selected"
                                }
                              })
                            : _vm._e(),
                          _vm.isBlocked
                            ? _c("vs-avatar", {
                                attrs: { icon: "alarm_on", color: "#adadad" }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "d-flex justify-content-center" }, [
                    _vm.file.app === "FEB"
                      ? _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Flujo de Febos",
                                expression: "'Flujo de Febos'"
                              }
                            ]
                          },
                          [
                            _c(
                              "vs-chip",
                              {
                                staticClass: "cursor-pointer mr-2",
                                class: { "text-success": _vm.wasCopied },
                                attrs: {
                                  color: "warning",
                                  "data-cy": "file-number"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.copyToClipboard(
                                      _vm.file.id,
                                      _vm.file.numero
                                    )
                                  }
                                }
                              },
                              [_vm._v(" " + _vm._s(_vm.file.numero) + " ")]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.file.app === "ED" &&
                    _vm.file.tipoObjetoId === "ARCHIVO-RP"
                      ? _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Repositorio",
                                expression: "'Repositorio'"
                              }
                            ]
                          },
                          [
                            _c(
                              "vs-chip",
                              {
                                staticClass: "cursor-pointer mr-2",
                                class: { "text-success": _vm.wasCopied },
                                attrs: {
                                  color: "primary",
                                  "data-cy": "file-number"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.copyToClipboard(
                                      _vm.file.id,
                                      _vm.file.numero
                                    )
                                  }
                                }
                              },
                              [
                                _c("vs-avatar", {
                                  attrs: { color: "primary", text: "R" }
                                }),
                                _vm._v(" " + _vm._s(_vm.file.numero) + " ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.file.app === "ED" && _vm.file.tipoObjetoId === "EXP"
                      ? _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Expediente",
                                expression: "'Expediente'"
                              }
                            ]
                          },
                          [
                            _c(
                              "vs-chip",
                              {
                                staticClass: "cursor-pointer mr-2",
                                class: { "text-success": _vm.wasCopied },
                                attrs: {
                                  color: "primary",
                                  "data-cy": "file-number"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.copyToClipboard(
                                      _vm.file.id,
                                      _vm.file.numero
                                    )
                                  }
                                }
                              },
                              [
                                _c("vs-avatar", {
                                  attrs: { color: "primary", text: "E" }
                                }),
                                _vm._v(" " + _vm._s(_vm.file.numero) + " ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.file.app === "ED" && _vm.file.tipoObjetoId === "ARCHIVO"
                      ? _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Archivo",
                                expression: "'Archivo'"
                              }
                            ]
                          },
                          [
                            _c(
                              "vs-chip",
                              {
                                staticClass: "cursor-pointer mr-2",
                                class: { "text-success": _vm.wasCopied },
                                attrs: {
                                  color: "primary",
                                  "data-cy": "file-number"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.copyToClipboard(
                                      _vm.file.id,
                                      _vm.file.numero
                                    )
                                  }
                                }
                              },
                              [
                                _c("vs-avatar", {
                                  attrs: { color: "primary", text: "A" }
                                }),
                                _vm._v(" " + _vm._s(_vm.file.numero) + " ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ]
              ),
              _c("vs-col", { attrs: { "vs-lg": "3" } }, [
                _vm._v(" " + _vm._s(_vm.file.nombre) + " "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "" + _vm.file.descripcion,
                        expression: "`${file.descripcion}`"
                      }
                    ]
                  },
                  [
                    _c("small", { staticClass: "text-primary" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("truncate")(_vm.file.descripcion, 40)) +
                          " "
                      )
                    ])
                  ]
                )
              ]),
              _c("vs-col", { attrs: { "vs-lg": "2" } }, [
                _vm._v(" " + _vm._s(_vm.file.autor) + " ")
              ]),
              _c(
                "vs-col",
                { attrs: { "vs-lg": "2" } },
                [
                  _vm.file.aprobacionesEjecucionEstadoId.toString() ===
                  _vm.FileStates.INITIATED
                    ? _c(
                        "vs-chip",
                        {
                          attrs: {
                            "data-cy": "flow-started",
                            title: "Iniciado"
                          }
                        },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "query_builder", color: "#43C3B9" }
                          }),
                          _vm._v(" Iniciado ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.aprobacionesEjecucionEstadoId.toString() ===
                  _vm.FileStates.PREPARED
                    ? _c(
                        "vs-chip",
                        { attrs: { title: "Pendiente" } },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "language", color: "#adadad" }
                          }),
                          _vm._v(" Preparado ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.aprobacionesEjecucionEstadoId.toString() ===
                  _vm.FileStates.APPROVED
                    ? _c(
                        "vs-chip",
                        {
                          attrs: {
                            "data-cy": "approved-flow",
                            title: "Aprobado"
                          }
                        },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "thumb_up", color: "#28c76f" }
                          }),
                          _vm._v(" Aprobado ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.aprobacionesEjecucionEstadoId.toString() ===
                  _vm.FileStates.REJECTED
                    ? _c(
                        "vs-chip",
                        {
                          attrs: {
                            "data-cy": "rejected-flow",
                            title: "Rechazado"
                          }
                        },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "thumb_down", color: "#ea5455" }
                          }),
                          _vm._v(" Rechazado ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.aprobacionesEjecucionEstadoId.toString() ===
                  _vm.FileStates.CANCELED
                    ? _c(
                        "vs-chip",
                        {
                          attrs: { "data-cy": "null-flow", title: "Retornado" }
                        },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "block", color: "#bf0303" }
                          }),
                          _vm._v(" Anulado ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.aprobacionesEjecucionEstadoId.toString() ===
                  _vm.FileStates.DISMISSED
                    ? _c(
                        "vs-chip",
                        {
                          attrs: {
                            "data-cy": "dismissed-flow",
                            title: "Desestimado"
                          }
                        },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "save_alt", color: "#848484" }
                          }),
                          _vm._v(" Desestimado ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "vs-col",
                { attrs: { "vs-lg": "2" } },
                [
                  _vm.file.tipoGrupo === "Oficina"
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Oficina",
                              expression: "'Oficina'"
                            }
                          ],
                          staticClass: "mr-4",
                          attrs: {
                            color: "dark",
                            transparent: "",
                            "data-cy": "office"
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.file.unidadNombre) + " ")]
                      )
                    : _vm._e(),
                  _vm.file.tipoGrupo === "Unidad"
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Unidad",
                              expression: "'Unidad'"
                            }
                          ],
                          staticClass: "mr-4",
                          attrs: {
                            color: "success",
                            transparent: "",
                            "data-cy": "unit"
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.file.unidadNombre) + " ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "vs-row",
            [
              _c(
                "vs-col",
                {
                  staticClass: "pt-2 border-top",
                  attrs: { "vs-offset": "1", "vs-lg": "10", "vs-type": "flex" }
                },
                [
                  _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Fecha inicio del proceso",
                          expression: "'Fecha inicio del proceso'"
                        }
                      ],
                      staticClass: "mr-4"
                    },
                    [
                      _c("vs-avatar", { attrs: { icon: "date_range" } }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("dateFormat")(_vm.file.fechaInicioProceso)
                          ) +
                          " "
                      )
                    ],
                    1
                  ),
                  _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Fecha actualización del proceso",
                          expression: "'Fecha actualización del proceso'"
                        }
                      ],
                      staticClass: "mr-4"
                    },
                    [
                      _c("vs-avatar", { attrs: { icon: "date_range" } }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("dateFormat")(_vm.file.fechaActualizacion)
                          ) +
                          " "
                      )
                    ],
                    1
                  ),
                  _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Proceso de pasos",
                          expression: "'Proceso de pasos'"
                        }
                      ],
                      staticClass: "mr-4",
                      attrs: { color: "primary", transparent: "" }
                    },
                    [
                      _c("vs-avatar", { attrs: { icon: "group" } }),
                      _vm._v(
                        " paso " +
                          _vm._s(_vm.file.numeroPaso) +
                          " de " +
                          _vm._s(_vm.file.totalPasos) +
                          " "
                      )
                    ],
                    1
                  ),
                  _vm.file.retenido === "Y"
                    ? _c(
                        "b-avatar",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Esta retenido",
                              expression: "'Esta retenido'"
                            }
                          ],
                          staticClass: "mr-4",
                          attrs: {
                            pill: "",
                            size: "28",
                            variant: "danger",
                            "data-cy": "detained"
                          }
                        },
                        [
                          _c("feather-icon", {
                            attrs: { size: "18", icon: "LockIcon" }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Nombre de documento en flujo",
                          expression: "'Nombre de documento en flujo'"
                        }
                      ],
                      staticClass: "mr-4",
                      attrs: { color: "warning", transparent: "" }
                    },
                    [
                      _c("vs-avatar", { attrs: { icon: "description" } }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("truncate")(_vm.file.objetoNombre, 20)
                          ) +
                          " "
                      )
                    ],
                    1
                  ),
                  _vm.view === "pre-oficina"
                    ? _c("steps-info-pre-office", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Estado del paso",
                            expression: "'Estado del paso'"
                          }
                        ],
                        attrs: {
                          step: _vm.file.aprobacionesTipoPasoId.toString()
                        }
                      })
                    : _vm._e(),
                  _vm.file.privado === "Y"
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Privado",
                              expression: "'Privado'"
                            }
                          ],
                          staticClass: "mr-4",
                          attrs: {
                            color: "primary",
                            transparent: "",
                            "data-cy": "private"
                          }
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "lock" } }),
                          _vm._v(" privado ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.folio
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Folio",
                              expression: "'Folio'"
                            }
                          ],
                          staticClass: "mr-4",
                          attrs: {
                            color: "warning",
                            transparent: "",
                            "data-cy": "document-folio"
                          }
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "description" } }),
                          _vm._v(" " + _vm._s(_vm.file.folio) + " ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.foliado
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Fecha de documento",
                              expression: "'Fecha de documento'"
                            }
                          ],
                          staticClass: "mr-4",
                          attrs: { color: "warning", transparent: "" }
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "date_range" } }),
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("dateFormat")(_vm.file.foliado)) +
                              " "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.tipoObjetoCategoria
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Tipo de documento",
                              expression: "'Tipo de documento'"
                            }
                          ],
                          staticClass: "mr-4",
                          attrs: {
                            color: "warning",
                            transparent: "",
                            "data-cy": "document-type"
                          }
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "description" } }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("truncate")(
                                  _vm.file.tipoObjetoCategoria,
                                  20
                                )
                              ) +
                              " "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.oficinaNombre
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Oficina que numeró o tramitó",
                              expression: "'Oficina que numeró o tramitó'"
                            }
                          ],
                          staticClass: "mr-4",
                          attrs: { color: "warning", transparent: "" }
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "apartment" } }),
                          _vm._v(" " + _vm._s(_vm.file.oficinaNombre) + " ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.app === "FEB"
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Tipo de documento en flujo",
                              expression: "'Tipo de documento en flujo'"
                            }
                          ],
                          staticClass: "mr-4",
                          attrs: { color: "warning", transparent: "" }
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "description" } }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.findTypeDocument(_vm.file.tipoReferencia)
                              ) +
                              " "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.numeroReferencia
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Número de documento",
                              expression: "'Número de documento'"
                            }
                          ]
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "tag" } }),
                          _vm._v(" " + _vm._s(_vm.file.numeroReferencia) + " ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.desatendida !== 1
                    ? _c(
                        "b-avatar",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Flujo atendido",
                              expression: "'Flujo atendido'"
                            }
                          ],
                          staticClass: "mr-4",
                          attrs: {
                            color: "#28c76f",
                            pill: "",
                            size: "28",
                            "data-cy": "attended-flow"
                          }
                        },
                        [
                          _c("feather-icon", {
                            attrs: { size: "18", icon: "BellIcon" }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.desatendida === 1
                    ? _c(
                        "b-avatar",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Flujo desatendido",
                              expression: "'Flujo desatendido'"
                            }
                          ],
                          staticClass: "mr-4",
                          attrs: {
                            color: "orange",
                            pill: "",
                            "data-cy": "unattended-flow",
                            icon: null,
                            variant: "warning",
                            size: "28"
                          }
                        },
                        [
                          _c("feather-icon", {
                            attrs: { size: "18", icon: "BellOffIcon" }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.plantilla
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Plantilla",
                              expression: "'Plantilla'"
                            }
                          ]
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "tag" } }),
                          _vm._v(" " + _vm._s(_vm.file.plantilla) + " ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "vs-col",
        {
          attrs: {
            "vs-lg": "1",
            "vs-type": "flex",
            "vs-justify": "center",
            "vs-align": "center"
          }
        },
        [
          _c("FileOptions", {
            attrs: { file: _vm.file, "select-file": _vm.selectFile }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }